import { lazy } from 'react';

export const EventSeriesListPage = lazy(() => import('./controller.js'));
